import apiClient from './client';

export const faqAPI = {
  getCategories: () => apiClient.get('/faq/categories'),
  createCategory: (data) => apiClient.post('/faq/categories', data),
  updateCategory: (id, data) => apiClient.put(`/faq/categories/${id}`, data),
  deleteCategory: (id) => apiClient.delete(`/faq/categories/${id}`),

  getQuestions: (params) => apiClient.get('/faq/questions', { params }),
  createQuestion: (data) => apiClient.post('/faq/questions', data),
  updateQuestion: (id, data) => apiClient.put(`/faq/questions/${id}`, data),
  deleteQuestion: (id) => apiClient.delete(`/faq/questions/${id}`),
  trackView: (id) => apiClient.post(`/faq/questions/${id}/view`),
  // #M11 — el backend no expone POST /questions/{id}/feedback (404
  // siempre); son dos endpoints separados que solo incrementan un
  // contador, sin leer body.
  trackFeedback: (id, useful) => apiClient.post(`/faq/questions/${id}/${useful ? 'helpful' : 'not-helpful'}`),
};
